<div class="w-[700px]" style="overflow: auto; max-height: 90vh; height: fit-content; margin: 12px">
  <div class="flex justify-between items-center p-4 border-b">
    <p class="m-0 font-bold text-xl">Invite New User</p>
    <span class="material-icons search-icon font-bold cursor-pointer text-[24px] text-k-blue" (click)="closeDialog()"> close </span>
  </div>
  <div
    class="flex justify-between px-6 py-5 mt-0 flex-col gap-8 pb-0"
    style="max-height: calc(90vh - 149px); overflow: auto"
    (click)="$event.stopPropagation()"
  >
    <div class="w-full">
      <form class="w-full" #inviteFormDirective="ngForm" [formGroup]="inviteForm">
        <p class="text-[#487AF0] font-semibold text-xs">User Details</p>
        <div class="flex mb-3 items-center">
          <mat-form-field appearance="fill" style="width: 100%; margin-bottom: 5px !important" class="app__invite-user-text-field">
            <mat-label class="automtic-form-desing-lable"> Email</mat-label>
            <input matInput placeholder="Email" required formControlName="inviteEmail" />
            @if (inviteForm.controls['inviteEmail'].value == '') {
            <mat-error>Email is required</mat-error>
            } @if (inviteForm.controls['inviteEmail'].value === current_user?.email) {
            <mat-error>You cannot invite yourself.</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="flex mb-3 items-center">
          <mat-form-field appearance="fill" style="width: 100%; margin-bottom: 5px !important" class="app__invite-user-text-field">
            <mat-label class="automtic-form-desing-lable">First Name</mat-label>
            <input required matInput placeholder="First Name" formControlName="first_name" />
            @if (inviteForm.controls['first_name'].value == '') {
            <mat-error>First name is required</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="flex mb-3 items-center">
          <mat-form-field appearance="fill" style="width: 100%; margin-bottom: 5px !important" class="app__invite-user-text-field">
            <mat-label class="automtic-form-desing-lable"> Last Name</mat-label>
            <input matInput placeholder="Last Name" required formControlName="last_name" />
            @if (inviteForm.controls['last_name'].value == '') {
            <mat-error>Last name is required</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="flex mb-3 items-center">
          <mat-form-field appearance="fill" style="width: 100%; margin-bottom: 5px !important" class="app__invite-user-text-field">
            <mat-label class="automtic-form-desing-lable"> Nickname (optional)</mat-label>
            <input matInput placeholder="Nickname" formControlName="your_self" />
          </mat-form-field>
        </div>

        <div class="flex items-center">
          <div class="w-full h-[80%]">
            <connect-relationship-dialog
              [hideText]="hideText"
              (relationshipId)="relationshipIdChanged($event)"
              (onDatePicked)="doSomething($event)"
              [fromInvite]="true"
              [data]="connection_relationship_data"
              [subMemberPlaceHolder]="'Relationship Type'"
            ></connect-relationship-dialog>
            @if (!inviteForm.controls['relationship_name'].valid && inviteForm.controls['relationship_name'].touched) {
            <p
              style="
                font-weight: 400 !important;
                color: #f44336;
                font-size: 12px;
                height: 18px;
                position: relative;
                top: -38px;
                padding: 0 1em;
                margin: 0px;
              "
            >
              Relationship Type is required
            </p>
            }
          </div>
        </div>
        <p class="text-[#487AF0] font-semibold text-xs">Note</p>
        <div class="flex mb-3 items-center">
          <mat-form-field
            class="app__medium--height--form app__invite-user-text-field"
            appearance="fill"
            style="width: 100%; margin-bottom: 5px !important"
          >
            <!-- <mat-label class="automtic-form-desing-lable"> Notes </mat-label> -->
            <textarea
              matInput
              placeholder="Add a note here..."
              maxlength="400"
              cdkAutosizeMinRows="6"
              style.maxHeight.px="48"
              style="overflow: auto; height: auto !important; max-height: 48px"
              formControlName="notes"
            >
            </textarea>
          </mat-form-field>
        </div>

        <p class="text-[#487AF0] font-semibold text-xs">License</p>

        <div class="flex gap-2 items-center">
          <mat-form-field appearance="fill" style="width: 100%" class="app__select-dropdown">
            <mat-label class="automtic-form-desing-lable">What type of user are they?</mat-label>
            <mat-select formControlName="userType" (selectionChange)="onUserTypeChange($event)">
              <mat-option value="Family">
                {{ 'Family' }}
              </mat-option>
              <mat-option value="Professional">
                {{ 'Professional' }}
              </mat-option>
              <mat-option value="viewOnly" matTooltip="View only users can only view files, and utilize direct delivery.">
                View Only
                <img style="height: 18px; margin: 4px 4px 4px 6px" src="assets/images/data-extraction-info.svg" />
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        @if(isPaymentFeatureEnabled){ @if (inviteForm.controls['userType'].value == 'Family' || (inviteForm.controls['userType'].value ==
        'Professional' && current_user?.user_type !== 'Standard')) {
        <div class="flex gap-2 items-center">
          <mat-form-field appearance="fill" style="width: 100%" class="app__select-dropdown">
            <mat-label class="automtic-form-desing-lable">
              Will this user be covered under
              {{
                current_user && current_user.userLicense && current_user?.userLicense?.fromUser && current_user?.userLicense?.fromUser?.name
                  ? current_user?.userLicense?.fromUser?.name
                  : current_user?.name
              }}?</mat-label
            >
            <mat-select formControlName="isUserAddedToLicense">
              @for (option of permissionOptions; track option) {
              <mat-option [value]="option">
                {{ option }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        } }
      </form>
    </div>
  </div>

  <hr class="mt-0" />
  <div class="flex w-full justify-end p-4 bottom-0 my-2 pt-0 mt-0 mb-0">
    <button
      [class]="
        inviteForm.valid
          ? 'app__btn--primary rounded-[8px] w-full h-full flex items-center justify-center m-0 p-4 text-base font-semibold'
          : 'app__btn--disabled rounded-[8px] w-full h-full flex items-center justify-center m-0 p-4 text-base font-semibold'
      "
      (click)="sendInvite()"
    >
      Invite
    </button>
  </div>
</div>
